import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { PALETTE_LIGHT, PALETTE_DARK, RADIUS, SHADOWS_LIGHT, SHADOWS_DARK, ICON_SIZES } from './tokens';
import typography from './typography';
import { buildComponentOverrides } from './components';

/**
 * Creates the full MUI theme for a given color mode.
 * @param {'light' | 'dark'} mode
 */
export function createAppTheme(mode) {
  const isLight = mode === 'light';
  const palette = isLight ? PALETTE_LIGHT : PALETTE_DARK;
  const shadows = isLight ? SHADOWS_LIGHT : SHADOWS_DARK;

  const muiShadowArray = [
    'none',
    shadows.xs,
    shadows.sm,
    shadows.sm,
    shadows.md,
    shadows.md,
    shadows.lg,
    shadows.lg,
    shadows.lg,
    shadows.lg,
    shadows.lg,
    shadows.lg,
    shadows.lg,
    shadows.lg,
    shadows.lg,
    shadows.lg,
    shadows.lg,
    shadows.lg,
    shadows.lg,
    shadows.lg,
    shadows.lg,
    shadows.lg,
    shadows.lg,
    shadows.lg,
    shadows.glowPrimary,
  ];

  const base = createTheme({
    palette: {
      mode,
      primary: {
        main: palette.primary.main,
        dark: palette.primary.dark,
        light: isLight ? '#FF8A50' : '#FFB07C',
        contrastText: palette.primary.contrastText,
        soft: palette.primary.soft,
      },
      secondary: {
        main: palette.secondary.main,
        contrastText: palette.secondary.contrastText,
      },
      accent: {
        main: palette.accent.main,
      },
      success: { main: palette.success.main },
      warning: { main: palette.warning.main },
      error: { main: palette.error.main },
      info: { main: palette.info.main },
      background: {
        default: palette.background.default,
        paper: palette.background.paper,
        elevated: palette.background.elevated,
        subtle: palette.background.subtle,
      },
      text: {
        primary: palette.text.primary,
        secondary: palette.text.secondary,
        tertiary: palette.text.tertiary,
      },
      divider: palette.divider,
      action: {
        hover: isLight ? 'rgba(242,101,34,0.06)' : 'rgba(255,138,80,0.1)',
        selected: isLight ? 'rgba(242,101,34,0.12)' : 'rgba(255,138,80,0.18)',
      },
    },
    typography,
    shape: {
      borderRadius: 4,
    },
    shadows: muiShadowArray,
    // Extended tokens accessible on the theme object
    radius: RADIUS,
    shadowsExt: shadows,
    iconSizes: ICON_SIZES,
    components: buildComponentOverrides(mode),
  });

  return responsiveFontSizes(base, { breakpoints: ['sm', 'md'], factor: 2 });
}
